<template>
	<nav class="dark-primary-color text-white menu-nav" :class="{
			'menu-visible': menuVisible && !$store.printMode,
			'icons-only' : iconsOnly
		}">
		<div v-if="!iconsOnly" class="name">
			You are logged in as <strong>{{ $store.userDetails.first_name }} {{ $store.userDetails.last_name }}</strong>

			<template v-if="$store.company && 'company_name' in $store.company && $store.company.company_name">
				to <strong>{{$store.company.company_name}}</strong>
			</template>
		</div>
		<ul>
			<nav-item v-for="(item,index) in navFilteredForPerms" 
				:icon="item.icon" 
				:link="'link' in item ? item.link : false"
				:click="'click' in item ? item.click : false" 
				:big="item.big" 
				:text="item.text"
				:highlight="'highlight' in item ? item.highlight : false"
				:icon-only="iconsOnly"
				:key="'link' in item ? index+item.link : index+item.click"
				:classes="item.classes"
				v-on:click="$emit($event)">
			</nav-item>
			<li v-if="!iconsOnly && ($store.environment == 'Demo' || $store.environment == 'Development')" class="text-center mt-2" style="cursor: pointer;" v-on:click="$emit('openUserSwitch')">
				Switch Users
			</li>
		</ul>

		<!--<div class="text-center change-log-text">
			<small><router-link to="/version" class="text-primary">Change Log</router-link></small>
		</div>-->
	</nav>

</template>

<script type="text/javascript">

import NavItem from "../components/NavItem"

export default {
	name: "MainMenu",
	props: [
		"menuVisible", //determines whether the menu is slide into view or not
		"iconsOnly"
	],
	components: {
		NavItem
	},
	data() {
		return {
			menuLeft: this.menuVisible ? 0 : '-300px',

			/*
			userModulePerms expects JSON in following format: {
				'module_name' : {
					read: true,
					write: false,
				},
				'another_module_name' : {
					read: true,
					write: false,
				}

			}
			*/
			userModulePerms: ("modulePermissions" in localStorage) ? JSON.parse(localStorage.modulePermissions) : {},
			userModulePerms: {
				'Users': {
					read: true,
					write: true
				}
			}
		}
	},
	computed: {
		navItems() {
			if (this.$store.companySetupMode) {
				return [
					{
						icon: "fa-exclamation",
						text: this.$store.appName+" Setup",
						link: "/setup",
						classes: "bg-success text-light"
					},
					{
						icon: "fa-exchange-alt",
						text: "Employers",
						link: "/employers"
					}
				]
			}
			else {

				return [
					{
						icon: "fa-tachometer-alt",
						big: true,
						text: "Dashboard",
						link: "/"
					},
					{
						icon: "fa-cubes",
						text: "Projects",
						link: "/projects/list"
					},
					{
						icon: "fa-wrench",
						text: "Services",
						link: "/services"
					},
					{
						icon: "fa-project-diagram",
						text: "Contacts Network",
						link: "/contacts",
						modulePermRequired: "Contacts"
					},
					{
						icon: "fa-truck",
						text: "Equipment",
						link: "/equipment/list",
						modulePermRequired: "Equipment"
					},
					{
						icon: "fa-tags",
						text: "Materials & Tasks",
						link: "/materials/list",
						modulePermRequired: "Materials"
					},
					{
						icon: "fa-users",
						text: "Employees",
						link: "/employees/list",
						modulePermRequired: "Users"
					},
					/*
					{
						icon: "fa-receipt",
						text: "Expenses",
						link: "/expenses/review",
						modulePermRequired: "Expenses"
					},
					*/
					{
						icon: "fa-clock",
						text: "Time Logs",
						link: "/time-logs/review",
						modulePermRequired: "TimeLogs"
					},
					{
						icon: "fa-file-invoice-dollar",
						text: "Financial",
						link: "/financial",
						anyModulePerms: ["Service Quotes/Invoices","Job Invoices","Purchase Orders","Projects","Expenses"]
					},
					{
						icon: "fa-medkit",
						text: "Health & Safety",
						link: "/safety/certificates/matrix",
						modulePermRequired: "Certificates"
					},
					{
						icon: "fa-clipboard-check",
						text: "Forms",
						link: "/forms/templates",
						modulePermRequired: "Company Forms"
					},
					/*
					{
						icon: "fa-calendar",
						text: "Calendar (old)",
						link: "/calendar"
					},
					*/
					{
						icon: "fa-calendar-alt",
						text: "Schedule",
						link: "/schedule"
					},
					{
						icon: "fa-map-pin",
						text: "Locates",
						link: "/locates",
						modulePermRequired: "Locates"
					},
					{
						icon: "fa-book",
						text: "Library",
						link: "/library/files"
					},
					/*{
						icon: "fa-search",
						text: "Find People",
						link: "/find"
					},
					{
						icon: "fa-pie-chart",
						text: "Reports",
						link: "/reports/services",
						modulePermRequired: "Services"
					},*/
					{
						icon: "fa-cog",
						text: "Settings",
						link: "/settings"
					},
					{
						icon: "fa-th-large",
						text: "Apps",
						link: "/apps/main"
					},
					{
						icon: "fa-exchange-alt",
						text: "Employers",
						link: "/employers"
					},
					{
						icon: "fa-bullhorn",
						text: "Referral Link",
						click: "openReferralModal",
						highlight: true
					}
				]
			}
		},
		navFilteredForPerms() {
			let vm = this

			let navItems = JSON.parse(JSON.stringify(this.navItems))

			let modulePerms = this.getUserModulePerms()

			if (this.$store.userDetails.tenant_id == 0 || !this.isOnActiveEmployer()) {

				let includeList = [
					"/employers"
				]

				return navItems.filter(item => {
					if (includeList.indexOf(item.link) >= 0)
						return true
				})
			}

			if (this.$store.clockedInJob) {

				//check if user is added to job

				let isOnJob = false
				if (this.$store.clockedInJob) 
					isOnJob = true

				if (isOnJob || this.$store.userRole == "Admin" || this.hasModulePermRead("Jobs")) {
					let type_segment, type_label
					if (this.$store.clockedInJob.type == "Service") {
						type_segment = "/service/"
						type_label = "Service"
					}
					else {
						type_segment = "/project/"
						type_label = "Project"
					}

					let link = "/dashboard"
					if (this.$store.clockedInJob.type == "Service")
						link = "/worksheet"

					navItems.splice(1,0,
						{
							icon: "fa-cube",
							text: type_label+ " " + this.$store.clockedInJob.job_num,
							link: type_segment+this.$store.clockedInJob.slug+link
						}
					)
				}
			}

			let isServiceTech = vm.userIsServiceTech()

			if (!("Services" in modulePerms)) {
				modulePerms = {
					Services: {
						read: false
					}
				}
			}

			if (!isServiceTech && this.getUserRoleType() != "Admin" && !modulePerms.Services.read) {	
				//strip out services menu

				navItems = navItems.filter(item => {
					if (!('text' in item) || item.link == "/services/mine") 
						return false
					else
						return true
				})
			}

			let nav = this.filterNavForPerms(navItems)

			if ("expiry" in this.$store.subscription && this.$store.subscription.type == 'Trial' && this.$store.company.is_free_user == 0) {
				//calc expiry
				let daysLeft = this.moment(this.$store.subscription.expiry).diff(this.moment(),"days")

				let text = ""
				if (daysLeft > 0) 
					text =  daysLeft+" days left on trial"
				else
					text = "Trial has expired"

				nav.push({
					icon: 'fa-credit-card',
					text: text,
					link: "/settings/tradetraks-subscription",
					classes: "text-danger"
				})
			}

			if ("AddonApp" in this.$store.company && this.$store.company.AddonApp) {
				let appsInMainSlot = this.$store.company.AddonApp.filter(app => app.ui_location == "Main")
				if (appsInMainSlot.length == 0) {
					let appNavItemIndex = nav.findIndex(item => item.text == "Apps")

					if (appNavItemIndex >= 0)
						nav[appNavItemIndex].link = "/apps/store"
				}
			}

			return nav
		}
	}		
}
</script>

<style type="text/css" scoped>

	nav {
		position: fixed;
		left: -270px;
		top: 45px;
		bottom: 0;
		width: 250px;
		padding: 10px;
		transition: 0.5s left, 0.5s width;
		z-index: 45;
		overflow-y: auto;
		overflow-x: hidden;
		color: var(--text-dark);
		background-color: var(--background-menus);
		border-right: 1px solid lightgray;
	}

	nav.icons-only {
		width: 80px;
		border-right: 1px solid #a2a09b
	}

	nav.menu-visible {
		left: 0;
	}

	nav a {
		color: inherit;
	}

	nav a:hover {
		text-decoration: none;
	}

	nav h2 .fa {
		font-size: 1em;
	}

	nav ul {
		list-style: none;
		padding: 0;
	}

	.name {
		font-size: 10pt;
	}

	.change-log-text {

		bottom: 10px;
		width: calc(100% - 20px);
	}

	@media (max-width: 500px) {
		nav.menu-visible {
			width: 100%;
		}

		nav ul {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			align-items: stretch;
		}
	}

</style>